import { defineStore } from "pinia";
import { IOrganisation, Organisation, SaveUserRequest, User } from "@/types";
import { useApi } from "@/services";
import { get } from "lodash-es";
import { AxiosResponse } from "axios";
import { useAxios } from "@/config";
interface AdminState {
  users: User[];
  organisation: Organisation | null;
  organisationsList: string[];
  userRolesList: string[];
}
export const useAdmin = defineStore("admin", {
  state: (): AdminState => ({
    users: [],
    organisation: null,
    organisationsList: [],
    userRolesList: [],
  }),
  actions: {
    async createOrganisation(createPayload: {
      organisationId: string;
      settings: Partial<IOrganisation>;
    }) {
      return useAxios().$http.post(useApi().createOrgSettings, createPayload);
    },
    async saveUser(payload: SaveUserRequest) {
      const users = [...this.users];
      return useAxios()
        .$http.put(useApi().saveUser, payload, { withCredentials: true })
        .then((r) => {
          const index = users.findIndex(
            (user) => user.username === payload.username
          );
          if (index > -1) {
            users.splice(
              index,
              1,
              new User({
                ...get(users, [index, "_data"]),
                ...JSON.parse(r.config.data),
              })
            );
          }
          this.users = users;
        });
    },
    async deleteOrganisation(organisationId: string) {
      return useAxios().$http.post(useApi().deleteOrgSettings, {
        organisationId,
      });
    },
    async updateOrganisation(updatePayload: {
      organisationId: string;
      settings: Partial<IOrganisation>;
    }) {
      return useAxios().$http.post(useApi().updateSettings, updatePayload);
    },
    async listOrganisations() {
      return useAxios()
        .$http.get<string, AxiosResponse<string[]>>(useApi().existingSettings)
        .then(({ data }) => {
          this.organisationsList = data;
        });
    },
    async listUserRoles() {
      return useAxios()
        .$http.get<string, AxiosResponse<string[]>>(useApi().getUserRoles, {
          withCredentials: true,
        })
        .then(({ data }) => {
          this.userRolesList = data;
        });
    },
    async getOrganisation(org: string) {
      return useAxios()
        .$http.get<string, AxiosResponse<IOrganisation>>(
          useApi().orgSettingsForOrganisation + org
        )
        .then(({ data }) => {
          this.organisation = new Organisation(data);
        });
    },
  },
});
